//import blossom from 'edmonds-blossom';
import blossom from '@/lib/blossom';
/**
 * Возвращает максимальное паросочетание среди игроков.
 * @param {Array} players - Массив игроков.
 * @param {Function} canPair - Функция-предикат: (id1, id2) => true/false
 * @returns {Array} Массив пар [ [id1, id2], ... ]
 */
export function findMaxMatching(players, canPair) {
  const edges = [];

  // Строим ребра: i < j, если можно создать пару
  for (let i = 0; i < players.length; i++) {
    for (let j = i + 1; j < players.length; j++) {
      const a = players[i].id;
      const b = players[j].id;
      if (canPair(a, b)) {
        edges.push([i, j, 1]); // вес 1
      }
    }
  }

  const matching = blossom(edges, players.length);

  // Преобразуем результат в список пар [id1, id2]
  const result = [];
  for (let i = 0; i < matching.length; i++) {
    const j = matching[i];
    if (j !== -1 && i < j) {
      result.push([players[i].id, players[j].id]);
    }
  }

  return result;
}

/**
 * Возвращает оптимальное паросочетание по минимизации штрафов.
 * @param {Array} players - Массив игроков.
 * @param {Function} getPenalty - Функция: (player1, player2) => число (чем меньше, тем лучше).
 * @param {Function} canPair - Функция-предикат: (player1, player2) => true/false
 * @returns {Array} Массив пар [ [id1, id2], ... ]
 */
export function findBestMatchingByPenalty(players, getPenalty, canPair = () => true) {
  const edges = [];
  const penalties = [];

  // Строим граф с весами по штрафам (Blossom ищет максимум, поэтому инвертируем веса)
  for (let i = 0; i < players.length; i++) {
    for (let j = i + 1; j < players.length; j++) {
      const p1 = players[i];
      const p2 = players[j];
      if (!canPair(p1, p2)) continue;
      const penalty = getPenalty(p1, p2);
      if (penalty !== Infinity) {
        const weight = 100000 - penalty; // Инвертируем, чтобы меньший penalty → больший вес
        edges.push([i, j, weight]);
        penalties.push(penalty);
      }
    }
  }

  const matching = blossom(edges, players.length);

  const result = [];

  for (let i = 0; i < matching.length; i++) {
    const j = matching[i];
    if (j !== -1 && i < j) {
      const edgeIndex = edges.findIndex(([a, b]) => (a === i && b === j) || (a === j && b === i));
      const penalty = penalties[edgeIndex];
      result.push([players[i].id, players[j].id, penalty]);
    }
  }

  return result;
}